/**
 * Get product data from json response
 *
 * @param {object} response
 */
export const getProductData = (response = {}, newFormat) => {
    const product = newFormat ? response.product_card : response.product;
    const result = {};

    if (typeof product !== 'undefined') {
        const productId = newFormat ? product.id : product.product_id;
        const variantId = newFormat ? product.variants[0].id : product.variant_id;

        result.productId = Number(productId);
        result.variantId = Number(variantId);
    }

    return result;
};
